<!--page starts-->
<section class="page-wrapper">
    <div class="event-hero-section margin-top-152 cf" [ngStyle]="{'background-image':'url(' + bannerList?.file + ')'}">
        <div class="container">
            <div class="event-hero-detail">
                <div class="event-hero-titel">
                    
                </div>
            </div>
        </div>
    </div>
    <div class="ticket-bottom-section" style="background-image: url(assets/images/tickets-bg-banner.jpg);">
        <div class="container">
            <div class="ticket-bottom-detail">
                <div class="buy-ticket-outdoor-event-box" *ngFor="let tickets of cricketsList?.data?.cricketevent">
                   <div class="buy-ticket-outdoor-event-content">
                       <h3 *ngIf="tickets?.title">{{tickets?.title}}</h3>
                       <div [innerHTML]="tickets?.description"></div>                      
                       <!-- <p>The big-hitting, fast-action T20 Vitality Blast competition is back!</p> -->
                   </div>
                   <div class="buy-ticket-outdoor-event-btn" *ngIf="tickets?.btn_title">
                       <a href="{{tickets?.btn_url}}">{{tickets?.btn_title}}</a>
                   </div>
                </div>               
            </div>
        </div>
    </div>
    <div class="ticket-outdoor-event-section">
        <div class="ticket-outdoor-event-tab-section">
            <div class="container">
                <div class="ticket-outdoor-event-tab">
                    <ul>
                        <li class="ticket-name" [ngClass]="{ active: i == 0 }" id="outdoor-{{crickets?.cricket_event_title_id}}" *ngFor="let crickets of cricketsList?.data?.cricketeventtitle; let i = index"><a href="#">{{crickets?.title}} </a></li>
                        <!-- <li class="ticket-name" id="international-cricket"><a href="#">international Cricket </a></li>
                        <li class="ticket-name active" id="outdoor-events"><a href="#">Outdoor Events</a></li> -->
                    </ul>
                </div>
            </div>
        </div>
        <div class="ticket-outdoor-event-tab-detail-section ticket-main-content" [ngClass]="{ active: i == 0 }"  id="outdoor-{{crickets?.cricket_event_title_id}}-content" *ngFor="let crickets of cricketsList?.data?.cricketeventtitle; let i = index">
            <div class="ticket-outdoor-event-tab-detail-top" *ngIf="crickets?.cricket_event_title_detail">
                <div class="container">
                    <div class="ticket-outdoor-event-tab-detail-top-detail" *ngFor="let detail of crickets?.cricket_event_title_detail">
                        <div class="ticket-outdoor-event-tab-detail-top-image">
                            <img [src]="detail?.image">
                        </div>
                        <div class="ticket-outdoor-event-tab-detail-top-content">
                            <div class="ticket-outdoor-event-tab-detail-top-content-titel">
                                <h2 class="titel-name">{{detail?.title}} </h2>
                            </div>
                            <div class="ticket-outdoor-event-tab-detail-top-content-text" [innerHTML]="detail?.description">
                                <!-- <p>Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. The passage is attributed to an unknown typesetter in the 15th century who is thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.</p> -->
                            </div>
                            <div class="ticket-outdoor-event-tab-detail-top-content-btn" *ngIf="detail?.btn_title_1 || detail?.btn_title_2">
                                <ul>
                                    <li *ngIf="detail?.btn_1_sold == 'No'"><a href="{{detail?.btn_url_1}}" class="red" *ngIf="detail?.btn_title_1">{{detail?.btn_title_1}}</a></li>
                                    <li *ngIf="detail?.btn_1_sold == 'Yes'"><a href="{{detail?.btn_url_1}}" class="grey" *ngIf="detail?.btn_title_1">{{detail?.btn_title_1}}</a></li>
                                    <li *ngIf="detail?.btn_2_sold == 'Yes'"><a href="{{detail?.btn_url_2}}" class="grey"  *ngIf="detail?.btn_title_2">{{detail?.btn_title_2}}</a></li>
                                    <li *ngIf="detail?.btn_2_sold == 'No'"><a href="{{detail?.btn_url_2}}" class="red"  *ngIf="detail?.btn_title_2">{{detail?.btn_title_2}}</a></li>
                                   
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ticket-outdoor-event-tab-detail-center">
                <div class="ticket-outdoor-cinema-top">
                    <div class="container">
                        <div class="ticket-outdoor-cinema-titel">
                            <h2 class="titel-name">Outdoor Cinema </h2>
                        </div>
                    </div>
                </div>
                <div class="ticket-outdoor-cinema-bottom">
                    <div class="ticket-outdoor-cinema-bg"></div>
                    <div class="container">
                        <div class="ticket-outdoor-cinema">
                            <div class="grace-road-detail">
                                <div class="grace-road-content">
                                    <div class="grace-road-event-btn"><a routerLink="/">Coming Soon Event</a></div>
                                </div>
                                <div class="grace-road-image-detail">
                                    <ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slideoutdoorcinemaConfig">
                                        <div ngxSlickItem class="grace-road-image-box slide">
                                            <a routerLink="/"><img src="assets/images/conference-img.png"></a>
                                        </div>
                                        <div ngxSlickItem class="grace-road-image-box slide">
                                            <a routerLink="/"><img src="assets/images/conference-img.png"></a>
                                        </div>
                                    </ngx-slick-carousel>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ticket-outdoor-event-tab-detail-bottom" *ngIf="cricketsList?.data?.cricketmembership">
                <div class="container">
                    <div class="ticket-outdoor-buy-membership">
                        <div class="ticket-outdoor-buy-membership-box" *ngFor="let membership of cricketsList?.data?.cricketmembership">
                            <div class="ticket-outdoor-buy-membership-titel">
                                <h2 class="titel-name">{{membership?.title}}</h2>
                            </div>
                            <div class="ticket-outdoor-buy-membership-image">
                                <a href="{{membership?.url}}" target="_blank">
                                    <img [src]="membership?.image">
                                </a>
                            </div>
                        </div>
                        <!-- <div class="ticket-outdoor-buy-membership-box">
                            <div class="ticket-outdoor-buy-membership-titel">
                                <h2 class="titel-name">View Hospitality</h2>
                            </div>
                            <div class="ticket-outdoor-buy-membership-image">
                                <img src="assets/images/shop-open-web.jpg">
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</section><!-- page ends-->
